module.exports = __webpack_public_path__ + "img/img1.378d9640.jpg";